import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MacUserService } from '../../../../../../services/user/mac-user.service';
import { AttendanceStaff_default_attendance_get } from '../../../../../../api_types';
import { ApiResponse, ApiServiceInterface, CrudComponent, CrudOptions, QueryServiceInterface } from '@hutsix/ngxh6';

@Component({
    selector: 'app-attendance-staff',
    templateUrl: './attendance-staff.component.html',
    styleUrls: ['./attendance-staff.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AttendanceStaffComponent implements OnInit {
    @Input() public objectId: string = null;

    public opts: CrudOptions = new CrudOptions({
        objectLabel: 'attendance',
        apiEndpoint: '/api/v1/attendance_staffs',
        queryKey: 'attendanceStaff',
        hideHeader: true,
        paginateBottom: true,
    });

    public r = (item: ApiResponse<AttendanceStaff_default_attendance_get[]>) => item;
    public c = (item: CrudComponent) => item;

    constructor(
        public cdRef: ChangeDetectorRef,
        public route: ActivatedRoute,
        @Inject('ApiService') public api: ApiServiceInterface,
        @Inject('QueryService') public queryService: QueryServiceInterface,
        @Inject('UserService') public user: MacUserService,
    ) {}

    ngOnInit(): void {
        this.opts.queryExtras = { 'user.id': this.objectId };
    }
}
